// Brief 85 §2 — OpponentModal, moved out of App.tsx's renderModals switch.
//
// MOVED, NOT REWRITTEN. The body below is byte-identical to the `case "op":`
// clause it left —
//   sha256 f2098b32cc3524337d9aafb5e94418dc8e047c97d21c4d3dc34b929bd814fce9
// — including its original indentation, which is why it sits deeper than this
// file's own wrapper. Only the imports, the Props type, the signature and the
// `return (` / `);` are new.
// Do not reformat: the indentation IS the proof.
//
// Props are the UNION of the names the body actually read in App scope, taken
// from a TypeScript-checker walk rather than chosen — a passed-but-unread prop
// would mean the union rule absorbed something it should have refused.
// The vocabulary props are typed by inference off makeModalFields' return, so
// this file adds nothing to the `any` ratchet.

import { ModalLayout } from "../SharedUI";
import { SK } from "../../utils";
import type { TFn } from "../../lib/taxonomyTypes";
import type { FieldSelectOption } from "../FieldSelect";
import type { makeModalFields } from "../modalFields";

type Vocab = ReturnType<typeof makeModalFields>;
type ModalForm = { id?: string | null; type?: string | null };

type Props = {
  F: Vocab["F"];
  NA: Vocab["NA"];
  PF: Vocab["PF"];
  S: Vocab["S"];
  T: Vocab["T"];
  _mt: Vocab["_mt"];
  clientTypesList: readonly FieldSelectOption[];
  clients: readonly unknown[];
  cm: () => void;
  form: ModalForm;
  opponents: readonly unknown[];
  saveEntityGuarded: (k: string, rows: readonly unknown[], set: (v: readonly unknown[]) => void, f: unknown, ext?: Record<string, unknown>) => void;
  setOpponents: (v: readonly unknown[]) => void;
  t: TFn;
};

export default function OpponentModal({
  F,
  NA,
  PF,
  S,
  T,
  _mt,
  clientTypesList,
  clients,
  cm,
  form,
  opponents,
  saveEntityGuarded,
  setOpponents,
  t,
}: Props) {
  return (
          <ModalLayout
            recordId={form.id} // 204 §G — the person's internal id in the header
            title={form.id ? _mt("Edit Opponent") : _mt("New Opponent")}
            onClose={cm}
            onSave={() =>
              saveEntityGuarded(SK.op, opponents, setOpponents, form, { type: form.type || "individual" })
            }
          >
              <>
                {/* Phase 43 CORRECTION (item 4 / RQ11) — default the empty type
                    to "individual" so the rendered field-set agrees with the
                    Type select's displayed first option (individual-first
                    clientTypesList) on initial mount, no toggle required. Matches
                    the cl modal. */}
                {S("Type", "type", clientTypesList)}
                {(form.type || "individual") === "company" ? (
                  <>
                    {F("Company Name *", "companyName", "", 1)}
                    <div className="field-row">
                      {F("VAT", "vat")}
                      {F(
                        t("cdd.field.bce", { fallback: "Enterprise number" }),
                        "bceNumber",
                      )}
                    </div>
                  </>
                ) : (
                  <>
                    {PF}
                    {F("National Register Number", "nationalRegister")}
                  </>
                )}
                {NA({
                  pool: opponents,
                  coiPool: clients,
                  typeLabel: t("type.opponent", { fallback: "opponent" }),
                })}
                {F("Contact", "contact")}
                {T("Notes", "notes")}
              </>
          </ModalLayout>
  );
}
